import { render, staticRenderFns } from "./Authorized.vue?vue&type=template&id=6fd44652&scoped=true"
import script from "./Authorized.vue?vue&type=script&lang=js"
export * from "./Authorized.vue?vue&type=script&lang=js"
import style0 from "./Authorized.vue?vue&type=style&index=0&id=6fd44652&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd44652",
  null
  
)

export default component.exports